import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CarouselGridItem,
  CarouselGridMainInnerBox,
  classes,
  TypographySubtitle,
  TypographyTitle,
} from './utils';
import { lightPalette } from '../../../../theme';
import { OCR_AUTHENTICATION_GRID } from '../../../../constants/staticContent';
import BlogCarousel from './BlogCarousel';

const AuthenticationNewLeftGrid = () => (
  <CarouselGridItem
    item
    className={classes.leftGrid}
    xs={12}
    sm={6}
    md={5.5}
    lg={4.5}
  >
    <CarouselGridMainInnerBox className={classes.leftGridInnerBox}>
      <Box className={classes.carouselLeftGridInnerBox}>
        <Typography
          color={lightPalette.secondaryWhite.main}
          className={classes.carouselGridTail}
        >
          <TypographyTitle component="span" color="#9F77EB">
            {OCR_AUTHENTICATION_GRID.TITLE.HEAD}
          </TypographyTitle>
          {OCR_AUTHENTICATION_GRID.TITLE.TAIL}
        </Typography>
        <TypographySubtitle
          className={classes.leftBoxSubtitle}
          variant="subtitle1"
          color={lightPalette.secondaryWhite.main}
        >
          {OCR_AUTHENTICATION_GRID.SUBTITLE}
        </TypographySubtitle>
      </Box>
      <Box className={classes.blogCarouselBox}>
        <BlogCarousel />
      </Box>
    </CarouselGridMainInnerBox>
  </CarouselGridItem>
);

export default AuthenticationNewLeftGrid;
